import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createPriceBook: [],
  loading: false,
  error: null,
};

const createPriceBookSlice = createSlice({
  name: "createPriceBook",
  initialState,
  reducers: {
    fetchCreatePriceBookRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreatePriceBookSuccess: (state, action) => {
      state.loading = false;
      state.createPriceBook = action.payload;
    },

    fetchCreatePriceBookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreatePriceBookRequest,
  fetchCreatePriceBookSuccess,
  fetchCreatePriceBookFailure,
} = createPriceBookSlice.actions;

export default createPriceBookSlice.reducer;